<template>
  <div>
    <el-card shadow="always">
      <h1>Items List</h1>
      <p v-if="loading">Loading...</p>
      <ul v-else>
        <li v-for="item in items" :key="item.id">{{ item.name }}</li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { fetchData } from '../api';

export default {
  name: 'Items',
  data() {
    return {
      items: [],
      loading: true,
    };
  },
  async created() {
    try {
      this.items = await fetchData('xxx');
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      this.loading = false;
    }
  },
};
</script>